import actions from './actions';
import getters from './getters';
import mutations from './mutations';
export var state = () => ({
  features: []
});
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};